import TransformFromPascalCase from 'components/Settings/Utilities/TransformFromPascalCase';
import ConfigData from 'config/ConfigData';
import React from 'react';
import { useSiteSectionsNames } from 'utils/getAppSite';

export const savedItemIconsMapping = {
  keyupdate: 'key-update',
  consultation: 'consultation',
  legislation: 'legislation',
  event: 'calendar',
  parliamentaryrecord: ConfigData.icons.parliament,
  hansardcontent: ConfigData.icons.parliament,
  countryspecificparliamentaryrecord: ConfigData.icons.parliament,
  seneddcommitteetranscript: ConfigData.icons.parliament,
  writtenquestion: ConfigData.icons.parliament,
  tweet: 'twitter-x',
  stakeholder: 'team',
  crmcontact: 'team',
  crminteraction: 'chat',
  policyask: 'policy-ask',
  briefingmaterial: 'briefing-material',
  research: 'briefing-material',
  newsrelease: 'briefing-material',
  commonslibraryarticle: 'library-material',
  committeepublication: 'document-bold',
  governmentpublication: 'manifesto',
  regulationdocument: 'document-bold',
  usercontent: 'briefing-material',
  upcomingevents: 'calendar',
  congressionalrecord: ConfigData.icons.parliament,
  regulationdocumentcomment: 'document-bold',
  regulation: 'document-bold',
};

const ContentTypeBadge = ({ objectType, name }) => {
  const { getName } = useSiteSectionsNames();

  const getTitle = (text) => {
    if (text === 'Country specific parliamentary record') {
      return 'Devolved parliament official report';
    } else if (text === 'Crm contact') {
      return 'CRM contact';
    } else if (text === 'Crm interaction') {
      return 'Interaction';
    } else {
      return text;
    }
  };
  return (
    <div>
      <span className={`icon-${savedItemIconsMapping[objectType.toLowerCase()]}`}></span>
      {name ?? getName({ property: getTitle(TransformFromPascalCase(objectType)) })}
    </div>
  );
};

export default ContentTypeBadge;
